<template>
  <modal name="privacy-policy" width="100%" height="auto" :scrollable="true" @before-open="beforeOpen">
    
    <h1 class="modal-label">Политика конфиденциальности</h1>
    <div class="b-text" v-html="text"></div>
      <div class="modal-buttons">
        <div class="modal-button" @click="hide">
          <span class="btn-icon"></span>
          <span class="btn-label">Закрыть</span>
        </div>
      </div>
  </modal>
</template>

<script>

import axios from "axios";
import { setting } from "../setting";

export default {
  name: "PrivacyPolicy",

  data() {
    return {
      text: null,
    }
  },

  methods: {
    hide() {
      this.$modal.hide("privacy-policy");
    },
    async beforeOpen() {
      await axios(setting.apiHost + `/v1/data/privacy-policy?theatreId=${this.$route.params.theatreId}`).then(response => {
          this.text = response.data.data;
        });
    },
  }
};
</script>

<style lang="scss">
.v--modal {
  background-color: #000000d5 !important;
  display: block;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &-overlay[data-modal="privacy-policy"] {
    overflow-x: hidden;
    .b-text {
      margin-bottom: 15px;
      p {
        margin-bottom: 8px;
      }
      strong {
        font-weight: bold;
      }
      a {
        color: #0d76ff;
      }
    }
    .modal-close {
      position: absolute;
      top: 20px;
      right: 20px;
      color: #fff;
      font-size: 28px;
      font-weight: normal;
      cursor: pointer;
    }
    .modal-button {
      padding: 0 30px;
    }
    .v--modal-box {
      padding: 20px 30px;
    }
  }
}

.modal {
  &-form {
    width: 335px;
  }
  &-label {
    display: block;
    padding: 0 10px 10px;
    font-size: 24px;
    margin-bottom: 20px;
    line-height: 24px;
    letter-spacing: 0.024em;
    color: #fff;
    text-align: center;
  }
  &-input {
    margin-bottom: 15px;
    input {
      border: none;
      outline: none;
      background-color: #fff;
      border-radius: 10px;
      padding: 16px 25px;
      font-size: 18px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
    }
  }
  &-buttons {
    display: flex;
    flex-wrap: nowrap;
  }
  &-button {
    margin: 0 15px 0 0;
    height: 56px;
    border-radius: 10px;
    border: 1px solid #fff;
    font-weight: 400;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 10px;
    text-align: center;
    justify-content: center;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    flex: 1;
    &:last-of-type {
      margin-right: 0;
    }
    &-primary {
      background-color: #0d76ff;
      border-color: transparent;
    }
  }
}
</style>
